export default __webpack_public_path__ + "static/media/bacancy_og.61e9f287.png";